import { useAtom, useAtomValue } from "jotai";
import * as React from "react";
import { useCallback, useMemo, useRef, useState } from "react";

import { useNavigate } from "react-router-dom";

import NotificationSettingsPanel from "../../components/app/notification-settings-panel";

import { appLog } from "../../util";
import ProfileDialog from "../profile/editor";

import { LinearProgress } from "@mui/material";
import MaterialModal from "../../components/app/material-modal";
import ProductFruitsWrapper from "../../components/ProductFruits/ProductFruitsWrapper";
import {
  baseAtom,
  blockListedBase,
  getUIStateIsOptionSelected,
  setUIStateIsOptionSelected
} from "../../stores/jotai/base";
import { discoverySessionAtom } from "../../stores/jotai/discovery-session";

export function containsAny(url: string, matches: string[]) {
  if (url === undefined) return false;

  for (let i = 0; i < matches?.length; i++) {
    if (url.includes(matches[i])) {
      return true;
    }
  }

  return false;
}

function changeUrl(url) {
  if (typeof history.pushState !== "undefined") {
    var newState = { additionalInformation: "New URL of Feature" };
    history.pushState(newState, document?.title, url);
  } else {
    console.warn(
      "Browser does not support HTML5 pushState.  Falling back to a regular location change"
    );
    try {
      //@ts-ignore
      window.location.url += "/" + url;
    } catch (e) {
      console.error(e);
    }
  }
}

export default function V3AppContainer() {
  const v3AppRef = useRef(null);
  const [base, setBase] = useAtom(baseAtom);
  const discoverySession = useAtomValue(discoverySessionAtom);
  const navigate = useNavigate();

  const [state, setState] = useState({
    appState: {},
    user: {},
    org: {},
    canvas: {},
    team: {},
    teams: [],
    wiki: {},
    cohort: {},
    cohorts: [],
    findings: [],
    members: {},
    media: {},
    note: {},
    transcript: {},
    interviews: {},
    notifications: {},
    findingTypes: {},
    pubStore: {},
    notificationsAreSet: {},
    routeOfUser: {},
    showSettings: false,
    baseAtomBridge: {},
    pageRequest: ""
  });

  const defaultLocation = () => {
    return "/";
  };
  const useableBase = blockListedBase(base, ["uppyFiles"]);

  const renderRoutesProps = useCallback(() => {
    return {
      ...useableBase,
      baseAtomBridge: useableBase,
      discoverySession: discoverySession,
      setBase: setBase,
      appState: useableBase ? useableBase.app : {},
      activityFeed: useableBase.activity
    };
  }, [useableBase, setBase, discoverySession]);
  const subRouteDataPackage = renderRoutesProps();

  const appState = base?.app;

  if (appState === undefined) {
    return <LinearProgress />;
  }

  const renderNotificationSettingsPanel = () => {
    const notificationSettingsOpen = getUIStateIsOptionSelected(
      base,
      "notification-settings"
    );

    return (
      <NotificationSettingsPanel
        setOpen={(target) => {
          setUIStateIsOptionSelected(
            setBase,
            base,
            "notification-settings",
            target
          );
        }}
        open={notificationSettingsOpen}
      />
    );
  };

  const pageServices = useMemo(() => {
    return (
      <>
        <MaterialModal
          title="Manage Profile"
          open={state.showSettings === true}
          handleDialogClose={() => setState({ ...state, showSettings: false })}
        >
          <ProfileDialog
            handleDialogClose={() =>
              setState({ ...state, showSettings: false })
            }
            user={base?.user}
            orgID={base?.org?.id}
            cohortID={base.cohort ? base?.cohort?.id : undefined}
          />
        </MaterialModal>
        {renderNotificationSettingsPanel()}
      </>
    );
  }, [subRouteDataPackage]);

  let innerContent = <></>;

  const biRouteChange = (route) => {
    appLog({
      routeChange: route
    });

    try {
      changeUrl(route);
    } catch (e) {}
  };

  React.useEffect(() => {
    let incomingPageRoute = undefined;

    try {
      //@ts-ignore
      incomingPageRoute = window?.location?.pathname;
    } catch (e) {}

    // if not given, use role to determine
    if (
      incomingPageRoute === undefined ||
      incomingPageRoute === "/" ||
      incomingPageRoute === ""
    ) {
      incomingPageRoute = defaultLocation();
    } else {
      navigate(incomingPageRoute);
    }

    biRouteChange(incomingPageRoute);
  }, []);

  return (
    <>
      <div ref={v3AppRef}></div>
      <ProductFruitsWrapper />
      {pageServices}
      {innerContent}
    </>
  );
}
